module.exports = __webpack_public_path__ + "img/SKMJ_limit3.84163ba1.jpg";